
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/csm-sales-and-order-management",
      function () {
        return require("private-next-pages/solutions/csm-sales-and-order-management/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/csm-sales-and-order-management"])
      });
    }
  